import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const AppRoute = ({ children, requiredPermission }) => {
	const location = useLocation();
	const permission = useSelector((state) => state.Login.permissionArry);

	if (permission?.length > 0 && requiredPermission) {
		let hasPermission = false;

		if (Array.isArray(requiredPermission)) {
			// Pass if user has at least one required permission
			hasPermission = requiredPermission.some(p => permission.includes(p));
		} else {
			// Single permission check
			hasPermission = permission.includes(requiredPermission);
		}

		if (!hasPermission) {
			return <Navigate to="/not-authorized" replace state={{ from: location }} />;
		}
	}

	return <>{children}</>;
};


export default AppRoute;

